// DEV-ONLY автологин под твоим аккаунтом для локального теста.
// ВАЖНО: импортируется ПЕРВЫМ в index.jsx — до создания redux-store,
// т.к. authReducer на старте читает isAuth из localStorage.refreshToken.
// Значения — из .env.development.local (в .gitignore, в прод не попадает).
// Выключить: REACT_APP_DEV_AUTOLOGIN='0'.
// Выключить только для вкладки (проверить вход/регистрацию): открыть любой URL
// с ?noautologin=1 — флаг живёт в sessionStorage этой вкладки; ?noautologin=0 — вернуть.
// Удобно в окне инкогнито: там localStorage пустой, страница входа доступна.

(() => {
  try {
    const m = window.location.search.match(/[?&]noautologin=([01])/);
    // Токены dev-сессии на время теста убираем в резерв (а не удаляем), чтобы
    // страницу входа можно было открыть в ОБЫЧНОМ окне; =0 — возвращаем.
    const KEYS = ["accessToken", "refreshToken", "idProfile", "tokenTime"];
    if (m && m[1] === "1") {
      window.sessionStorage.setItem("devNoAutologin", "1");
      if (!window.localStorage.getItem("devSessionBackup")) {
        const backup: Record<string, string> = {};
        KEYS.forEach((k) => {
          const v = window.localStorage.getItem(k);
          if (v !== null) { backup[k] = v; }
        });
        window.localStorage.setItem("devSessionBackup", JSON.stringify(backup));
      }
      KEYS.forEach((k) => window.localStorage.removeItem(k));
    } else if (m && m[1] === "0") {
      window.sessionStorage.removeItem("devNoAutologin");
      const raw = window.localStorage.getItem("devSessionBackup");
      if (raw) {
        const backup = JSON.parse(raw) as Record<string, string>;
        Object.keys(backup).forEach((k) => window.localStorage.setItem(k, backup[k]));
        window.localStorage.removeItem("devSessionBackup");
      }
    }
    (window as any).__DEV_NO_AUTOLOGIN__ = window.sessionStorage.getItem("devNoAutologin") === "1";
  } catch (e) {
    (window as any).__DEV_NO_AUTOLOGIN__ = false;
  }
})();

const DEV_AL =
  process.env.REACT_APP_ENV_MODE === "development" &&
  process.env.REACT_APP_DEV_AUTOLOGIN !== "0" &&
  !(window as any).__DEV_NO_AUTOLOGIN__ &&
  !!process.env.REACT_APP_DEV_ACCESS_TOKEN;

if (DEV_AL) {
  const seed: Record<string, string | undefined> = {
    accessToken: process.env.REACT_APP_DEV_ACCESS_TOKEN,
    refreshToken: process.env.REACT_APP_DEV_REFRESH_TOKEN,
    idProfile: process.env.REACT_APP_DEV_ID_PROFILE,
    fingerPrint: process.env.REACT_APP_DEV_FINGERPRINT,
  };

  const ensure = () => {
    try {
      Object.keys(seed).forEach((k) => {
        if (seed[k] && !window.localStorage.getItem(k)) {
          window.localStorage.setItem(k, seed[k] as string);
        }
      });
      if (!window.localStorage.getItem("tokenTime")) {
        window.localStorage.setItem("tokenTime", new Date().toISOString());
      }
    } catch (e) {
      /* localStorage недоступен (приватный режим старых браузеров) */
    }
  };

  ensure();

  // Блокируем удаление защищённых ключей через removeItem (axios и т.п.).
  try {
    const orig = window.localStorage.removeItem.bind(window.localStorage);
    (window.localStorage as any).removeItem = (key: string) => {
      if (key in seed) return;
      orig(key);
    };
  } catch (e) {
    /* метод может быть неизменяемым — тогда полагаемся на сторож ниже */
  }

  // delete localStorage.x обходит removeItem — ловим сторожем: если ключ
  // пропал, восстанавливаем. Так dev-сессию невозможно разлогинить.
  setInterval(ensure, 700);
}

export {};
